import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getIncomeCostInput,
  getIncomeCostsInput,
  IncomeCostLiteModel,
  IncomeCostModel,
} from './model';

export function useGetIncomeCosts(
  input?: getIncomeCostsInput,
  options?: UseQueryOptions<ExtendedApiResult<IncomeCostLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<IncomeCostLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getIncomeCosts', input?.params],
      () =>
        QueryFetchFunction({
          url: 'income-and-costs',
          params: input?.params,
        }),
      options,
    ),
    IncomeCostLiteModel,
  );
}

export function useGetIncomeCost(
  input?: getIncomeCostInput,
  options?: UseQueryOptions<ApiResult<IncomeCostModel>, ApiError>,
): UseQueryResult<ApiResult<IncomeCostModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getIncomeCost', input?.id],
      () =>
        QueryFetchFunction({
          url: `income-and-costs/${input?.id}`,
        }),
      options,
    ),
    IncomeCostModel,
  );
}

export function getIncomeCostsKey(input?: getIncomeCostsInput) {
  return ['getIncomeCosts', input?.params];
}

export function getIncomeCostKey(input?: getIncomeCostInput) {
  return ['getIncomeCost', input?.id];
}
